import { render, staticRenderFns } from "./OfferFormTextTabs.vue?vue&type=template&id=67250608&"
import script from "./OfferFormTextTabs.vue?vue&type=script&lang=js&"
export * from "./OfferFormTextTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports